import {
  ProgressDataResponse,
  LLMToolCallBlock,
  LLMConversationHistory,
  LLMMessageBlock,
  LLMMessage,
  LLM_ROLES,
} from 'llm/deep-research/DeepResearchDAO';
import {
  DeepResearchTools,
  ProgressData,
  ProgressToolCall,
} from 'llm/deep-research/messages/DeepResearchProgress';

/**
 * Converts a ProgressDataResponse from the backend to the ProgressData format
 * expected by the frontend components.
 */
export function convertProgressDataResponseToProgressData(
  progressDataResponse: ProgressDataResponse
): ProgressData {
  const {chatMetadata, conversationHistories} = progressDataResponse;

  const childConversationIds = new Set(chatMetadata.rootNode.children.map((child) => child.conversationId));

  const childConversationHistories = Object.values(conversationHistories).filter((history) =>
    childConversationIds.has(history.conversationId)
  );
  const historyThread = getProgressToolCalls(childConversationHistories);

  // TODO (BNCH-126864): Add other sources to progress data
  const numSources = 0;

  return {
    historyThread,
    numSources,
  };
}

const toolsToInclude = [
  DeepResearchTools.SearchTool,
  DeepResearchTools.DomainGraphQueryTool,
  DeepResearchTools.DomainGraphSchemaTool,
  DeepResearchTools.NotebookQueryTool,
  DeepResearchTools.QueryWarehouseTool,
  DeepResearchTools.Think,
];

export function getProgressToolCalls(
  conversationHistories: Array<LLMConversationHistory>
): Array<ProgressToolCall> {
  const toolCalls = conversationHistories
    .flatMap((history) =>
      history.messages
        .filter((message: LLMMessage) => message.role === LLM_ROLES.ASSISTANT)
        .flatMap((message: LLMMessage) =>
          message.messageBlocks
            .filter(
              (block: LLMMessageBlock) =>
                block.type === 'tool_call' && toolsToInclude.includes((block.value as LLMToolCallBlock).name)
            )
            .map((block) => ({
              tool: (block.value as LLMToolCallBlock).name,
              description: '',
              createdAt: new Date(message.createdAt),
            }))
        )
    )
    .sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

  // TODO (BNCH-126793): Add tool summarized tool calls to frontend
  return toolCalls;
}
